import { defineComponent as _defineComponent } from 'vue'
import { useLazyAsyncData, useRoute, useNuxtApp } from '#app'
import { setCookie } from '~/utility/cookies'
import {
  currenciesContainer,
  CurrenciesProvider,
  ICurrenciesProvider,
} from '../currencies/inversify.config'


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencySwitch',
  emits: ["click"],
  setup(__props, { emit }: { emit: ((e: 'click') => void), expose: any, slots: any, attrs: any }) {

const { $i18n } = useNuxtApp()


const route = useRoute()
const lang = route.params.lang || 'en-gb'
const { data: currencies } = useLazyAsyncData(
  `currencies-${lang}`,
  async () => {
    return Object.values(
      await currenciesContainer.get<CurrenciesProvider>(ICurrenciesProvider)(),
    )
  },
)

function isCurrentCurrency(currency) {
  return $i18n.current.currency === currency.code
}

function setCurrency(currencyCode) {
  setCookie('pu-currency', currencyCode)
  $i18n.current.currency = currencyCode
  emit('click')
}

return { __sfc: true,$i18n, emit, route, lang, currencies, isCurrentCurrency, setCurrency }
}

})